<template>
    <b-modal ref="cancellationModal" header-class="anchor-modal" :title="title">
        <p class="mb-2" v-html="this.description">
        </p>
        <div slot="modal-footer" class="w-100 btn-row">
            <b-btn class="btn-danger" @click="$emit('deleteClick')">
              {{ this.deleteButtonLabel }}
            </b-btn>
            <b-btn class="" @click="hide">Cancel</b-btn>
        </div>
    </b-modal>
</template>

<script>

export default {
  props: {
    title: String,
    description: String,
    deleteButtonLabel: String,
  },
  methods: {
    show() {
      this.$refs.cancellationModal.show();
    },
    hide() {
      this.$refs.cancellationModal.hide();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/utils/CancellationModal.vue